import useDurationLimitCheck from 'hooks/useDurationLimitCheck'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { dispatch } from 'store'
import { editorThunks } from 'store/features/editor/thunks'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { recentlyUsedMediaThunks } from 'store/features/recentlyUsedMedia/thunks'
import { IBaseMediaItem, MediaStatus } from 'types/media'
import { scrollToElementById } from 'utils'
import { convertBaseItemToMediaItem } from 'utils/media'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { useResponsive } from './useResponsive'
import { useVisualMediaPlacement } from './timeline/useVisualMediaPlacement'
import { useTimelineContext } from 'context/TimelineContext'

export const useAddAiItemToTimeline = () => {
  const isTablet = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const defaultDimensions = useSelector(projectDataSelectors.defaultDimensions)
  const { isDurationAllowed } = useDurationLimitCheck()
  const getPlacement = useVisualMediaPlacement()
  const { setPlayHeadCurrentTime, isPlaying } = useTimelineContext()

  return useCallback(
    (mediaItem: IBaseMediaItem) => {
      if (!isDurationAllowed(mediaItem.duration)) {
        return null
      }

      const placement = getPlacement(mediaItem.duration)

      const preparedItem = convertBaseItemToMediaItem(
        mediaItem,
        placement.startTime,
        defaultDimensions,
        placement.zIndex
      )

      dispatch(
        projectDataThunks.addMediaItems({
          value: [preparedItem],
          config: { applySelection: false, isUndoable: true }
        })
      )
      dispatch(
        editorThunks.setActiveTimelineItems([
          {
            id: preparedItem.id,
            type: preparedItem.type
          }
        ])
      )
      scrollToElementById(preparedItem.id)
      setPlayHeadCurrentTime(placement.startTime, isPlaying)

      if (isTablet) {
        dispatch(editorThunks.setIsMobileSubSidebarOpen(false))
      }

      if (preparedItem.meta.status === MediaStatus.OK) {
        dispatch(
          recentlyUsedMediaThunks.updateRecentlyUsedItemsOnInsertFromMediaLibrary(
            [preparedItem]
          )
        )
      }
    },
    [
      defaultDimensions,
      isDurationAllowed,
      isTablet,
      getPlacement,
      isPlaying,
      setPlayHeadCurrentTime
    ]
  )
}
